<!-- 
新增工单动态
  props:
    showAddNew: 是否显示该弹窗
  emit:
    refresh 刷新列表

 -->

<template>
  <div class="add-dynamic">
    <div class="dyna-content">
      <textarea
        v-model="textarea"
        ref="textArea"
        class="text-area"
        @keyup="mention"
        placeholder="点此输入工单动态...">
      </textarea>
      <div class="mention-result" v-show="mentionList.length">
        <ul>
          <li class="first">
            <span class="text">选择你要@的人</span>
          </li>
          <li
            class="me-item"
            v-for="(item, index) in mentionList"
            :class="{actived: Mcurrent === index}"
            @click="selectMention(item)"
            @mouseover="changeCurrent(index)">
            <span class="text">{{item.value}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="upload-wrap">
      <el-upload
        multiple
        :limit="9"
        :on-exceed="fileUploadLimitHook"
        v-show="showImgBox"
        class="img-box"
        list-type="picture-card"
        :action="uploadUlr"
        :data="uploadData"
        :accept="imgAccept"
        :on-success="handlePictureSuccess"
        :on-remove="handlePictureRemove"
        :on-error="handleError"
        :file-list="imgList"
        :before-upload="handleBeforeUpload">
        <i class="el-icon-plus" @click="set_upload_param"></i>
      </el-upload>

      <el-upload
        v-show="showFileBox"
        class="file-box"
        :action="uploadUlr"
        :data="uploadData"
        :on-success="handleFileSuccess"
        :on-remove="handleFileRemove"
        :on-error="handleError"
        :before-upload="handleBeforeUpload"
        :file-list="fileList"
        :limit="9"
        :on-exceed="fileUploadLimitHook">
        <el-button size="small" type="primary" @click="set_upload_param">点击上传</el-button>
      </el-upload>
    </div>
    <div class="dyna-options">
      <el-badge :value="images.length" :hidden="!images.length" class="item">
        <span @click="toggleImgBox">
          <span class="web-icon-img"></span>
          <span class="text">图片</span>
        </span>
      </el-badge>
      <el-badge :value="attachment.length" :hidden="!attachment.length" class="item">
        <span @click="toggleFileBox">
          <span class="web-icon-file"></span>
          <span class="text">附件</span>
        </span>
      </el-badge>
      <el-button size="small" type="primary" @click="handleSubmit">发 送</el-button>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import atSomeone from 'components/common/comment-box/at-someone'
import uploadMix from 'src/config/upload-mixin'
import { Message } from 'element-ui'

export default {

  name: 'add-dynamic',

  props: {
    id: {
      type: Number,
      default: 0
    }
  },

  data () {
    return {
      images: [], // 关联图片
      attachment: [], // 附件
      refType: 'workOrder',
      apiUrl: api.path,
      showImgBox: false,
      showFileBox: false,
      fileList: [],
      imgList: []
    }
  },

  mixins: [atSomeone, uploadMix],

  methods: {
    // 监听图片删除
    handlePictureRemove (file, fileList) {
      this.images = this.images.filter(item => {
        if (item.indexOf(file.uid) > -1) {
          return false
        } else {
          return true
        }
      })
      this.imgList = fileList
    },

    // 监听图片上传成功
    handlePictureSuccess (response, file, fileList) {
      this.images.push(this.fileUrl[file.uid] + '?' + file.uid)
      this.imgList = fileList
    },

    // 监听附件删除
    handleFileRemove (file, fileList) {
      this.attachment = this.attachment.filter(item => {
        if (item.attachIndex.indexOf(file.uid) > -1) {
          return false
        } else {
          return true
        }
      })
      this.fileList = fileList
    },

    // 监听附件上传成功
    handleFileSuccess (response, file, fileList) {
      this.attachment.push({
        filename: file.name,
        attachIndex: this.fileUrl[file.uid] + '?' + file.uid,
        ext: file.name.replace(/.+\./, '').toLowerCase(),
        size: file.size
      })
      this.fileList = fileList
    },

    // 展开&收起图片上传模块
    toggleImgBox () {
      this.showImgBox = !this.showImgBox
      this.showFileBox = false
    },

    // 展开&收起附件上传模块
    toggleFileBox () {
      this.showFileBox = !this.showFileBox
      this.showImgBox = false
    },

    // 提交
    handleSubmit () {
      this.textarea = this.textarea.trim()
      if (this.textarea || this.images.length || this.attachment.length) {
        const url = '/commentApi/save.html'
        let params = {
          refId: this.id,
          refType: this.refType,
          content: this.textarea.replace(this.refName, ''),
          refUserId: this.refUserId,
          images: this.images,
          attachment: this.attachment
        }
        api.post(url, params, (data) => {
          Message({
            type: 'success',
            message: '发送成功！'
          })
          this.resetParams()
          this.$emit('update')
        })
      } else {
        Message({
          type: 'error',
          message: '不允许提交空的工单动态！'
        })
      }
    },

    resetParams () {
      this.textarea = ''
      this.images = []
      this.attachment = []
      this.fileList = []
      this.imgList = []
    }
  }
}
</script>


<style lang="less" scoped>
@import "../../../assets/less/variable.less";
.add-dynamic {
  box-shadow: 0 -2px 6px 0 rgba(0, 0, 0, 0.05);
  position: relative;
  z-index: 49;
  .dyna-content {
    position: relative;
    .text-area {
      border: none;
      outline: none;
      display: block;
      padding: 0;
      width: 100%;
      height: 58px;
      box-sizing: border-box;
      padding: 10px 15px;
      font-size: 13px;
      resize: none;
    }
    .mention-result {
      position: absolute;
      left: 30px;
      bottom: 30px;
      z-index: 48;
      width: 200px;
      background-color: #fff;
      box-shadow: 0 0 4px 0 rgba(114, 114, 114, 0.5);
      padding: 2px;
      border-radius: 2px;
      overflow: auto;
      font-size: 13px;
      .first {
        padding: 5px 10px;
      }
      .me-item {
        padding: 8px 10px;
        cursor: pointer;
        &:hover,
        &.actived {
          background-color: #f3f5f7;
          color: @bg-orange;
        }
      }
    }
  }
  .upload-wrap {
    background: #f8fbff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05) inset;
    .img-box {
      padding: 15px;
      min-height: 82px;
    }
    .file-box {
      padding: 15px;
      min-height: 82px;
    }
  }
  .dyna-options {
    background-color: #f5f9ff;
    height: 42px;
    line-height: 42px;
    text-align: right;
    padding: 0 30px;
    border-top: 1px solid #e5ecf7;
    /deep/.el-badge__content {
          background-color:#6a82a4;
          height: 14px;
          line-height: 14px;
          padding: 0px 4px;
          font-size: 10px;
        }
    .item {
      float: left;
      margin-right: 36px;
      color: #95a8c2;
      font-size: 16px;
      cursor: pointer;
      position: relative;
      &.active {
        &:before {
          content: "";
          position: absolute;
          left: 26px;
          top: -6px;
          width: 10px;
          height: 10px;
          border: 1px solid #e5ecf7;
          background-color: #f8fbff;
          transform: rotate(45deg);
        }
        &:after {
          content: "";
          position: absolute;
          left: 25px;
          top: -8px;
          width: 15px;
          height: 8px;
          background-color: #f8fbff;
        }
      }
      .text {
        font-size: 14px;
        margin-left: 5px;
      }
      .num {
        position: absolute;
        left: 52px;
        top: 2px;
        text-align: center;
        height: 16px;
        line-height: 15px;
        padding: 0 6px;
        font-size: 12px;
        border-radius: 8px;
        background-color: #f00;
        color: #fff;
        transform: scale(0.8);
      }
    }
    .el-button {
      padding: 6px 12px;
    }
  }
}
</style>

<style lang="less">
.add-dynamic {
  .upload-wrap {
    .img-box {
      .el-upload--picture-card {
        width: 80px;
        height: 80px;
        line-height: 80px;
        border-radius: 2px;
      }
      .el-upload-list__item {
        width: 80px;
        height: 80px;
        border-radius: 2px;
        transition: none;
      }
      &.disabled {
        .el-upload {
          background-color: #eef1f6;
          cursor: not-allowed;
          &:hover {
            border-color: #c0ccda;
            color: #c0ccda;
          }
        }
      }
    }
    .file-box {
      .el-upload-list {
        display: inline-block;
        width: 450px;
        .el-upload-list__item {
          transition: none;
        }
      }
      .el-upload {
        display: inline-block;
        vertical-align: top;
        margin-top: 7px;
        margin-right: 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// add-dynamic.vue?403222da